import Vue from "vue";
import App from "./App.vue";
import store from "./store/store";
import VueRouter from "vue-router";
import routes from "./routes";
import VueMoment from "vue-moment";
import VModal from "vue-js-modal";
import VueCarousel from "vue-carousel";
Vue.use(VueCarousel);

Vue.use(VModal);
Vue.use(VueRouter);
Vue.use(VueMoment);

Vue.config.productionTip = false;
const router = new VueRouter({ routes, mode: "history" });
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
